import React from 'react';
import Header from '../components/Header';
import { Link } from 'react-router-dom';

function Home() {
    return (

        <div className="index-one">


            <Header />

            <div id="smooth-wrapper">
                <div id="smooth-content">


                    <div className="banner-area banner-style-one banner-bg-1 hero__area-3 banner__jump">
                        <div className="shape-image">
                            <img src="assets/images/banner/06.png" alt="banner" />
                        </div>
                        <div className="top-center-image rts-scroll-down-circle-wrapper-3">
                            <a href="/portfolio" className="speen-shape scroll-down-circle-3">
                                <svg className="uni-circle-text-path uk-text-secondary uni-animation-spin" viewBox="0 0 100 100" width="180" height="180">
                                    <defs>
                                        <path id="circle" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
                                    </defs>
                                    <text fontSize="11.75">
                                        <textPath xlinkHref="#circle">Project Showcase • Project Showcase •</textPath>
                                    </text>
                                </svg>
                                <i className="fa-solid fa-star-sharp"></i>
                            </a>
                        </div>
                        <div className="container">
                            <div className="row  ptb--200 ptb_sm--150">
                                <div className="col-lg-9">
                                    <div className="banner-one-wrapper mt--80 mt_sm--0">
                                        <h1 className="title rts_hero__title">
                                            Welcome to <br />
                                            <span className="border-bottom-1">Warmonks</span> Your <br />
                                            Tech Companion<br /> on a Mission
                                        </h1>

                                        <div className="bannerJump_animation banner-jump-button rts-scroll-down-circle-wrapper-4">
                                            <div className="jump__anim rts_round_btn_wrap scroll-down-circle-4">
                                                <div className="rts-mouse-move-button">
                                                    <div className="btn_wrapper">
                                                        <a href="/services"
                                                            className="rts-btn-mouse-move btn-hover btn-item"><span></span> Explore
                                                            Our <br />
                                                            Services
                                                            <i className="fa-solid fa-arrow-up-right"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="rts-about-area-1 rts-section-gapBottom">
                        <div className="shape-about-one">
                            <img src="assets/images/about/05.png" alt="about" />
                        </div>
                        <div className="container-full">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="grid-lines-wrapper">
                                        <div className="grid-lines">
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="gsap-inner sec1">
                                        <div className="image-wrapper-main-about mt-dec-135 rts-reveal-one">
                                            <img src="assets/images/about/01.jpg" alt="about" className="rts-reveal-image-one" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-split-wrap-about scrolltext-wrapper">
                                <div className="text-split scrollingText-two">
                                    <h2 className="title">
                                        Digital Agency Solutions <span>for Your Business</span>
                                        Digital Agency Solutions <span>for Your Business</span>
                                        Digital Agency Solutions <span>for Your Business</span>
                                    </h2>
                                </div>
                            </div>
                        </div>

                        <div className="container mt--100">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="left-main-about-inner">
                                        <img src="assets/images/about/02.png" alt="about" />
                                        <div className="shape-about-two">
                                            <img src="assets/images/about/06.png" alt="about" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 pl--60 pl_sm--15 pt_md--50 pt_sm--30">

                                    <div className="about-area-right-start">
                                        <div className="inner-about-wrapper">
                                            <div className="title-area">
                                                <span className="sub-title">About Us</span>
                                            </div><br />
                                            <h2 className="title quote">Best Web Development Conpany in Thrissur</h2>
                                            <p className="disc rts-text-anim">
                                                Warmonks, founded by a team of passionate tech professionals takes pride in being the best web and mobile application development company in Thrissur. Our team of experienced professionals at Warmonks is always enthusiastic about their passion for technology and dedicated to excellence.  Our experts will bring every project the way you need and ensure we deliver the best quality results. We are committed to converting your ideas into reality with the latest technology and our best service. We have years of experience in the industry and completed numerous projects in different sectors.
                                            </p>

                                            <div className="btn--area-left mt--50">
                                                <a href="/about" className="learn-more-btn">View More<i
                                                    className="fa-solid fa-arrow-up-right"></i></a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="our-approch-area-style-one rts-section-gap bg-dark-1">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="grid-lines-wrapper">
                                        <div className="grid-lines">
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 rts-slide-right-gsap">

                                    <div className="approch-area-left">
                                        <div className="title-area-left-wrapper">
                                            <div className="title-area">
                                                <span className="sub-title" style={{ color: 'gray' }} >Why Choose Us</span>
                                            </div>
                                            <h2 className="title quote">Comprehensive Digital Solutions for Every Need</h2>
                                        </div>
                                        <p className="disc rts-text-anim">
                                            We, at Warmonks, create solutions and opportunities for growth, innovation, and success. We care most about your growth and success. We measure our success by how much we contribute to your business' growth. We are here to be the go-to partner that helps you ride the tides of ever-changing digital realms-from a startup to an established business and individual who is simply looking to make a mark in the virtual world. Our years of experience are helpful for understanding the intricacies of different industries that we will use as avenues in order to ensure effective solutions that drive results.
                                        </p>
                                        <a href="/contact" className="learn-more-btn">Get in Touch <i
                                            className="fa-solid fa-arrow-up-right"></i></a>
                                    </div>

                                </div>
                                <div className="col-lg-6 col-md-6 rts-slide-left-gsap mt_sm--30">

                                    <div className="single-approach-area-start">
                                        <div className="left-area">
                                            <h3 className="title">Customized Solutions</h3>
                                            <p className="disc rts-text-anim">We provide customized solutions for your unique requirements.<br></br> For every project, warmonks create the best solutions that meet your expectations.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="single-approach-area-start two">
                                        <div className="left-area">
                                            <h3 className="title">Team of Expert Professionals</h3>
                                            <p className="disc rts-text-anim">Our staff at Warmonks who have many years of<br></br> knowledge in the business, deliver excellent results.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="single-approach-area-start three mb--0">
                                        <div className="left-area">
                                            <h3 className="title">Comprehensive Services</h3>
                                            <p className="disc rts-text-anim">From web and app development to digital marketing and beyond,<br></br> we've got all your digital needs covered.
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rts-section-gap rts-service-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="title-area">
                                        <span className="sub-title">Our SERVICES</span>
                                    </div>
                                    <div className="title-top-service-varticle">
                                        <h2 className="title">Transforming Your Business with<br></br> Innovative Solutions</h2>
                                        <p className="dsic">
                                            We offer a wide range of services to help businesses succeed in the digital world at Warmonks. Whether you are looking to build a website, a mobile app, or need to enhance your online presence, Warmonks is here to assist you. We have a team of experienced professionals who have years of knowledge in the industry. we are dedicated in providing the best results for your requirements.
                                        </p>
                                        <a href="/services" className="learn-more-btn">View More<i
                                            className="fa-solid fa-arrow-up-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="service-area-one-main-wrapper">

                                        <div className="single-item-service-one">
                                            <a href="/websitedevelopment">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/60.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>Website Development</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        We create dynamic and responsive websites that can provide flawless experiences on every device. Our team collaborates with you to create a website that displays your brand, engages your audiences, and converts.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="single-item-service-one">
                                            <a href="/appdevelopment">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/60.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>App Development</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        We at Warmonks stay ahead in designing mobile apps - creating high and innovative apps from both the domains of Android to iOS. Warmonks mainly focus on UI and UX-friendly interfaces to let everyone feel at the best about how their apps look during usage.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="single-item-service-one">
                                            <a href="/ecommercedevelopment">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/61.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>E-commerce Development</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        From secured, scalable, and feature-rich e-commerce platforms based on your needs to shopping experiences for a product catalog and payment integration, our teams make it happen seamlessly.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="single-item-service-one">
                                            <a href="/digitalmarketing">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/62.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>Digital Marketing</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        We are a digital marketing service company that will help you reach the right audience and get the most bang for your buck. Whether it is social media marketing or paid ads, Warmonks has got your back with customized strategies that boost engagement, more leads, and increase sales.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="single-item-service-one">
                                            <a href="/seo">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/63.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>SEO</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        Warmonks offers expert SEO services, which help to improve your rankings, drive organic traffic, and enhance your online presence. We work on the on-page and off-page SEO to achieve the best result.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="single-item-service-one">
                                            <a href="/graphicsdesigning">
                                                <div className="rts-img-contaciner">
                                                    <figure className="list-img">
                                                        <img className="list-img" src="assets/images/product/63.jpg"
                                                            alt="Stream Shop" />
                                                    </figure>
                                                </div>
                                                <div className="list-title col-md-6">
                                                    <h3>Graphic Designing</h3>
                                                </div>
                                                <div className="list-info col-md-3">
                                                    <p className="disc">
                                                        Warmonks creates awesome designs to make sure your brand message shines through. We mix creativity and strategy to create designs that connect with your target audience.
                                                    </p>
                                                </div>
                                                <div className="button-area">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.67 384.67">
                                                        <g>
                                                            <path fill-rule="evenodd"
                                                                d="M0 45.26l276.05 276.05H22.63v63.36h362.04V22.63h-63.36v253.42L45.26 0 0 45.26z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rts-use-case-area-one rts-section-gap bg-dark-1">
                        <div className="container-full">
                            <div className="col-lg-12">
                                <div className="main-wrapper-case-studies scrolltext-wrapper">
                                    <div className="scrollingText">
                                        <h2 className="title">
                                            our <span>Case</span> Studies .
                                            our <span>Case</span> Studies .
                                            our <span>Case</span> Studies .
                                            our <span>Case</span> Studies .
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <main className="carticle-slide-active">
                            <div className="scroller-wrapper">
                                <div className="scroller">
                                    <div className="slide">
                                        <div className="container-full-150 mt--110 mt_md--50 mt_sm--30">
                                            <div className="flot-right-150">
                                                <div className="use-case-area-start">
                                                    <div className="content-wrapper">
                                                        <span className="sub-title">Our Project</span>
                                                        <h2 className="title">
                                                            Veloxis
                                                        </h2>
                                                        <p>
                                                            Showcasing the agency's work in creating visually <br /> appealing,
                                                            user-friendly, and responsive websites
                                                        </p>
                                                        <a href="https://veloxis.ae/" className="learn-more-btn"
                                                            target="_blank" style={{ color: '#fff' }}>VIEW CASE <i
                                                                className="fa-solid fa-arrow-up-right"></i></a>
                                                    </div>
                                                    <a href="/portfolio" className="img-wrapper">
                                                        <img className="images" src="assets/images/Our Project/veloxis.png"
                                                            alt="product" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="slide">
                                        <div className="container-full-150 mt--110 mt_md--50 mt_sm--30">
                                            <div className="flot-right-150">
                                                <div className="use-case-area-start">
                                                    <div className="content-wrapper">
                                                        <span className="sub-title">Our Project</span>
                                                        <h2 className="title">
                                                            Cobra<br /> Ship Management
                                                        </h2>
                                                        <p className="disc">
                                                            Showcasing the agency's work in creating visually <br /> appealing,
                                                            user-friendly, and responsive websites
                                                        </p>
                                                        <a href="https://cobrashipmanagement.com/" className="learn-more-btn"
                                                            target="_blank" style={{ color: '#fff' }}>VIEW CASE <i
                                                                className="fa-solid fa-arrow-up-right"></i></a>
                                                    </div>
                                                    <a href="/portfolio" className="img-wrapper">
                                                        <img className="images" src="assets/images/Our Project/cobra.png"
                                                            alt="product" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="slide">
                                        <div className="container-full-150 mt--110 mt_md--50 mt_sm--30">
                                            <div className="flot-right-150">
                                                <div className="use-case-area-start">
                                                    <div className="content-wrapper">
                                                        <span className="sub-title">Our Project</span>
                                                        <h2 className="title">
                                                            US2U
                                                        </h2>
                                                        <p className="disc">
                                                            Showcasing the agency's work in creating visually <br /> appealing,
                                                            user-friendly, and responsive websites
                                                        </p>
                                                        <a href="https://www.us2u.in/" className="learn-more-btn"
                                                            target="_blank" style={{ color: '#fff' }}>VIEW CASE <i
                                                                className="fa-solid fa-arrow-up-right"></i></a>
                                                    </div>
                                                    <a href="/portfolio" className="img-wrapper">
                                                        <img className="images" src="assets/images/Our Project/us2u.png"
                                                            alt="product" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>


                    <div className="rts-pricing-area rts-section-gap position-relative">
                        <div className="container-2">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="grid-lines-wrapper">
                                        <div className="grid-lines">
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row brad-pricing-area-start">

                                <div className="col-lg-12">
                                    <div className="brand-area-style-one">
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/01.png"
                                            alt="brand" /></a>
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/02.png"
                                            alt="brand" /></a>
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/03.png"
                                            alt="brand" /></a>
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/04.png"
                                            alt="brand" /></a>
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/05.png"
                                            alt="brand" /></a>
                                        <a className="rts-skew-up-gsap" href="#"><img src="assets/images/brand/06.png"
                                            alt="brand" /></a>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="large-image-option-start rts-section-gap bg-dark-1 position-relative rts_jump_counter__animation">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="grid-lines-wrapper">
                                        <div className="grid-lines">
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="title-area-inner large-image">
                                        <h2 className="title quote">Digital Expertise Action <br /> <span> digital services.</span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-160">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="large-video-playing grow">
                                        <video autoPlay muted loop playsInline preload="metadata">
                                            <source src="assets/images/video/02.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container mt--120">
                            <div className="row">
                                <div className="col-lg-12">

                                    <div className="counter-up-wrapper counter_animation">
                                        <div className="counter-single counter__anim">
                                            <div className="inner">
                                                <h2 className="title"><span className="counter">362</span>k</h2>
                                                <p>Project <br />
                                                    Completed</p>
                                            </div>
                                        </div>
                                        <div className="counter-single counter__anim">
                                            <div className="inner">
                                                <h2 className="title"><span className="counter">300</span>M</h2>
                                                <p>Happy <br />
                                                    Customers</p>
                                            </div>
                                        </div>
                                        <div className="counter-single counter__anim">
                                            <div className="inner">
                                                <h2 className="title"><span className="counter">62</span>+</h2>
                                                <p>Years <br />
                                                    Experience</p>
                                            </div>
                                        </div>
                                        <div className="counter-single counter__anim">
                                            <div className="inner">
                                                <h2 className="title"><span className="counter">105</span>k</h2>
                                                <p>Awards <br />
                                                    Achievement</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="trusted-clients-area-start rts-section-gap">
                        <div className="right-shape-testi">
                            <img src="assets/images/testimonials/03.png" alt="testimonials" />
                        </div>
                        <div className="container-full">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="main-wrapper-case-studies scrolltext-wrapper">
                                        <div className="scrollingText-three">
                                            <h2 className="title">
                                                our <span>Trusted Client</span> Say .
                                                our <span>Trusted Client</span> Say .
                                                our <span>Trusted Client</span> Say .
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row g-5 mt--80 mt_sm--30">
                                <div className="col-lg-8 pr--100 pr_md--50 pr_sm--20">
                                    <div className="swiper-testimonails-style-one-main-wrapper">
                                        <div className="swiper mySwiper-testimonial-1">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">

                                                    <div className="single-testimonials-main-wrapper">
                                                        <div className="star-area-start">
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                        </div>
                                                        <div className="body">
                                                            <div className="quote-img">
                                                                <img src="assets/images/testimonials/02.png" alt="" />
                                                            </div>
                                                            <p className="disc">
                                                                Choosing Warmonks was the best decision I made for my website project. They truly are the number 1 website development company in Kerala, providing a seamless and efficient experience from start to finish. A special mention to Gayathri, who went above and beyond to ensure all my requirements were met. Her attention to detail and friendly communication made the experience even better. If you're looking for top website developers, Warmonks is the place to go!
                                                            </p>
                                                            <div className="author-area">
                                                                <div className="thumbnail">
                                                                    <img src="assets/images/testimonials/01.png"
                                                                        alt="testimonials" />
                                                                </div>
                                                                <div className="info-wrapper">
                                                                    <h6 className="title">vaseem abdulla</h6>
                                                                    <span>Client</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="swiper-slide">

                                                    <div className="single-testimonials-main-wrapper">
                                                        <div className="star-area-start">
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                        </div>
                                                        <div className="body">
                                                            <div className="quote-img">
                                                                <img src="assets/images/testimonials/02.png" alt="" />
                                                            </div>
                                                            <p className="disc">
                                                                Warmonks created a great website for us, even better than I expected. They were responsive and attentive to our needs throughout the development process. I would recommend their services to anyone looking for a custom website.
                                                            </p>
                                                            <div className="author-area">
                                                                <div className="thumbnail">
                                                                    <img src="assets/images/testimonials/01.png"
                                                                        alt="testimonials" />
                                                                </div>
                                                                <div className="info-wrapper">
                                                                    <h6 className="title">Jino George</h6>
                                                                    <span>Client</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="swiper-slide">

                                                    <div className="single-testimonials-main-wrapper">
                                                        <div className="star-area-start">
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                        </div>
                                                        <div className="body">
                                                            <div className="quote-img">
                                                                <img src="assets/images/testimonials/02.png" alt="" />
                                                            </div>
                                                            <p className="disc">
                                                                We recently collaborated with Warmonks to create a website for our UK-based care agency, Ideal Care Solutions (ideal-care.uk). Our experience with them was seamless, and the outcome exceeded our expectations. Warmonks delivered a top-notch, responsive website that meets our specific needs.

                                                                If you're looking for a reliable partner to develop a website for your care home services or healthcare services, look no further than Warmonks. We're 100% satisfied with their work, and I'm confident you will be too.
                                                            </p>
                                                            <div className="author-area">
                                                                <div className="thumbnail">
                                                                    <img src="assets/images/testimonials/01.png"
                                                                        alt="testimonials" />
                                                                </div>
                                                                <div className="info-wrapper">
                                                                    <h6 className="title">Akhil Johnson</h6>
                                                                    <span>Client</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="swiper-slide">

                                                    <div className="single-testimonials-main-wrapper">
                                                        <div className="star-area-start">
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                        </div>
                                                        <div className="body">
                                                            <div className="quote-img">
                                                                <img src="assets/images/testimonials/02.png" alt="" />
                                                            </div>
                                                            <p className="disc">
                                                            I had an excellent experience with Warmonks, the best website development company in Thrissur. They are definitely the top website developers in the area, providing a custom-made website that exceeded my expectations in design and functionality. The team's professionalism and dedication to producing great work were amazing. Warmonks truly understands consumers' demands, and I strongly suggest their services.
                                                            </p>
                                                            <div className="author-area">
                                                                <div className="thumbnail">
                                                                    <img src="assets/images/testimonials/01.png"
                                                                        alt="testimonials" />
                                                                </div>
                                                                <div className="info-wrapper">
                                                                    <h6 className="title">Akshay Satheesh E</h6>
                                                                    <span>Client</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="button-area-next-prev">
                                                <div className="swiper-button-next"></div>
                                                <div className="swiper-button-prev"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="after-effect-testi-right-img">
                                        <div className="thumbnail-clients-img rts-reveal-two">
                                            <img className="rts-reveal-image-two" src="assets/images/about/04.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="blog-area-start rts-section-gap bg-dark-1">
                        <div className="container">
                            <div className="row g-5">
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <div className="blog-left-wrapper-area-one">
                                        <div className="content-wrapper">
                                            <span className="sub-title">Update Blog</span>
                                            <h2 className="title quote">
                                                READ UPDATED <br />
                                                JOURNAL
                                            </h2>
                                            <p className="disc rts-text-anim">
                                                Irna torquent accumsan aliquet a metus netus tellus <br /> egestas, eu semper
                                                tortor fusce duis massa morbi <br /> parturient ornare.
                                            </p>
                                            <a href="/blogs" className="learn-more-btn" style={{ color: '#fff' }}>VIEW BLOG <i
                                                className="fa-solid fa-arrow-up-right"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-12 col-12 rts-slide-left-gsap">
                                    <div className="blog-single-main-wrapper style-one">
                                        <a href="blog-details.html" className="thumbnail">
                                            <div className="imgae-box">
                                                <img src="assets/images/blog/01.jpg" alt="blog" />
                                            </div>
                                        </a>
                                        <div className="inner">
                                            <div className="head">
                                                <span className="date">March 25, 2023</span>
                                                <span className="time">8 min read</span>
                                            </div>
                                            <div className="body">
                                                <a href="blog-details.html">
                                                    <h4 className="title">Marketing Musings: Insights from a <br /> Social Media
                                                        Marketer</h4>
                                                </a>
                                                <a href="blog-details.html" className="rts-btn btn-primary mt--30">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 col-12 rts-slide-left-gsap">
                                    <div className="blog-single-main-wrapper style-one">
                                        <a href="blog-details.html" className="thumbnail">
                                            <div className="imgae-box">
                                                <img src="assets/images/blog/02.jpg" alt="blog" />
                                            </div>
                                        </a>
                                        <div className="inner">
                                            <div className="head">
                                                <span className="date">March 25, 2023</span>
                                                <span className="time">8 min read</span>
                                            </div>
                                            <div className="body">
                                                <a href="blog-details.html">
                                                    <h4 className="title">Social media platforms are like ecosystems with its own
                                                        rules</h4>
                                                </a>
                                                <a href="blog-details.html" className="rts-btn btn-primary mt--30">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row rts-section-gapTop">
                                <div className="col-lg-12">
                                    <div className="card-tilt--off">
                                        <div className="cta-main-wrapper-one rts-slide-up-gsap">
                                            <div className="right-bg-image">
                                                <img src="assets/images/cta/02.png" alt="bg-cta" />
                                            </div>
                                            <div className="left-area">
                                                <img src="assets/images/cta/01.png" alt="cta-main-wrapper" />
                                            </div>
                                            <div className="cta-mid-area">
                                                <h3 className="title">Let’s make <span>something <br />
                                                    great</span> together</h3>
                                                <p className="disc">
                                                    we are dedicated to helping businesses achieve <br /> their goals through
                                                    innovative digital solutions.
                                                </p>
                                            </div>
                                            <div className="button-area-right">
                                                <a href="/getaqute" className="rts-btn btn-white">Get Quote <i
                                                    className="fa-light fa-arrow-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rts-footer-area-one rts-section-gapTop">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="grid-lines-wrapper">
                                        <div className="grid-lines">
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                            <div className="grid-line"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row rts-section-gapBottom">
                                <div className="col-lg-12">
                                    <div className="footer-main-wrapper-one">

                                        <div className="footer-left-area">
                                            <a href="/" className="logo-footer">
                                                <img className="logo-1" src="assets/images/footer-logo.png" alt="lolo-area" />
                                                <img className="logo-2" src="assets/images/logo/03.svg" alt="lolo-area" />
                                            </a>
                                            <p className="disc">
                                            Warmonks was born on a shared dream of a group<br /> of tech enthusiasts who came together to make use<br /> of the power of technology to create meaningful<br /> changes. Passion and a very clear vision did propel<br /> us and made our step toward building impactful digital<br /> solutions making life simplified and empowering a<br /> business to make the best out of it.

                                            </p>
                                            <div className="rts-social-area-one">
                                                <ul>
                                                    <li><a href="https://www.facebook.com/profile.php?id=100075545787839" target='_blank'><i class="fa-brands fa-facebook-f"></i></a></li>
                                                    <li><a href="https://www.instagram.com/team_warmonks/" target='_blank'><i class="fa-brands fa-instagram"></i></a></li>
                                                    <li><a href="https://api.whatsapp.com/send?phone=919778544561&text=We%20welcome%20you%20to%20join%20us....%E2%98%BA%EF%B8%8F" target='_blank'><i class="fa-brands fa-whatsapp"></i></a></li>
                                                    <li><a href="https://www.linkedin.com/company/warmonks/posts/?feedView=all" target='_blank'><i class="fa-brands fa-linkedin"></i></a></li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="footer-single-wized-start">
                                            <h5 className="title" style={{ color: '#000' }}>Quick Links</h5>
                                            <ul className="footer-nav">
                                                <li><a href="/">Home</a></li>
                                                <li><a href="/about">About Us</a></li>
                                                <li><a href="/services">Services</a></li>
                                                <li><a href="/portfolio">Portfolio</a></li>
                                                <li><a href="/blogs">Blogs</a></li>
                                                <li><a href="/contact">Contact</a></li>
                                                <li><a href="/getaqute">Get a quote</a></li>
                                            </ul>
                                        </div>

                                        <div className="footer-single-wized-start">
                                            <h5 className="title" style={{ color: '#000' }}>Our Services</h5>
                                            <ul className="footer-nav">
                                                <li><a href="#">Website Development</a></li>
                                                <li><a href="#">Mobile Application Development</a></li>
                                                <li><a href="#">Ecommerce Development</a></li>
                                                <li><a href="#">Digital Marketing</a></li>
                                                <li><a href="#">Search Engine Optimization</a></li>
                                                <li><a href="#">Graphic Designing</a></li>
                                            </ul>
                                        </div>

                                        <div className="footer-single-wized-start">
                                            <h5 className="title" style={{ color: '#000' }}>Contact Info</h5>
                                            <div className="mail-contact-area">
                                                <div className="single-con-info mb--40">
                                                    <a href="#">
                                                        3rd  Floor, SSS Plaza,<br /> Mahatma Nagar,<br /> Kizhakkumpattukara,<br />
                                                        Thrissur, Kerala 680005
                                                    </a>
                                                </div>
                                                <div className="single-con-info mail">
                                                    <a href="mailto:support@warmonks.com">
                                                        support@warmonks.com
                                                    </a>
                                                </div>
                                                <div className="single-con-info">
                                                    <a href="tel:+91 9778544561">
                                                        +91 9778544561
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="copyright-area text-center">
                                        <div className="left">
                                            <p>2025 © Warmonks. All rights reserved.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>





            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default Home
